"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./logic"), exports);
__exportStar(require("./clinical"), exports);
__exportStar(require("./uncertainty"), exports);
__exportStar(require("./datetime"), exports);
__exportStar(require("./interval"), exports);
__exportStar(require("./quantity"), exports);
__exportStar(require("./ratio"), exports);
//# sourceMappingURL=datatypes.js.map